const metaData = [
    {
        path: '/',
        title: 'PEMGARDA&reg; (pemivibart) | Official Landing Page',
        description: 'Discover PEMGARDA resources based on your role as a healthcare professional or patient. Make your appropriate selection for tailored information and support.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/patient/',
        title: 'FAQ - INVIVYD',
        description: 'FDA Authorization Materials Fact Sheet for Patients, Parents, and Caregivers FDA Emergency Use Authorization Letter Patient Savings Brochure EMERGENCY USE AUTHORIZATION PEMGARDA has been authorized by FDA for the emergency use described above. It is not FDA-approved for any use, including use for pre-exposure prophylaxis of COVID-19. PEMGARDA is authorized only for the duration of […]',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/patient/infusion-center-locator/',
        title: 'Infusion Center Locator - INVIVYD',
        description: 'Infusion Center Locator Search for infusion centers near you by entering your city or ZIP Code or click the link below to request inclusion of your facility. PEMGARDA™ Infusion Sites of Care:Sites of care that have experience administering PEMGARDA and/or are available to receive PEMGARDA referrals from your healthcare provider. Number of active sites NOTICE [&hellip;]',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/',
        title: 'PEMGARDA&reg; (pemivibart) | Official Physician Site',
        description: 'PEMGARDA has FDA authorization for use in certain moderately to severely immunocompromised patients. Learn more about guideline recommendations today.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/about/',
        title: 'About PEMGARDA&reg; (pemivibart) | Appropriate Patients',
        description: 'PEMGARDA has FDA authorization for use in certain moderately to severely immunocompromised patients. Discover which patients could be right for PEMGARDA.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/mechanism-of-action/',
        title: 'PEMGARDA&reg; (pemivibart) MOA | Mechanism of Action',
        description: 'PEMGARDA is a monoclonal antibody therapy that targets SARS-CoV-2 with ongoing evaluation against emerging variants. Discover more about its mechanism of action.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/trial-design/',
        title: 'PEMGARDA&reg; (pemivibart) Trial Design | CANOPY Phase 3',
        description: 'PEMGARDA was studied in the CANOPY trial. Explore trial design, objectives, and more.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/efficacy/',
        title: 'PEMGARDA&reg; (pemivibart) Efficacy | Immunobridging &amp; Efficacy',
        description: 'Review selected adverse reactions experienced by patients who received PEMGARDA in the CANOPY trial, including hypersensitivity reactions and common adverse events.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/safety/',
        title: 'PEMGARDA&reg; (pemivibart) Safety | Selected Adverse Events',
        description: 'Review the safety of PEMGARDA in more than 600 patients who received at least 1 dose. Details include hypersensitivity reactions and common adverse events.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/dosing/',
        title: 'PEMGARDA&reg; (pemivibart) Dosing &amp; Administration | Infusion',
        description: 'PEMGARDA is administered as a single intravenous (IV) infusion over a minimum of 1 hour for patients age 12 and older. See more details on dosing and storage.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/support-resources/',
        title: 'PEMGARDA&reg; (pemivibart) Resources and Patient Support',
        description: 'Learn about resources and patient support to assist with access to PEMGARDA.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/patient-support/',
        title: 'PEMGARDA&reg; (pemivibart) Patient Support | INVIVYD Care',
        description: 'INVIVYD Care is a patient support program available to help facilitate access to PEMGARDA.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/order-now/',
        title: 'PEMGARDA&reg; (pemivibart) Order Now | Product Information',
        description: 'Explore the PEMGARDA product ordering information, specialty pharmacies, and packaging details. You can also download a handy guide for easy reference.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/infusion-center-locator/',
        title: 'PEMGARDA&reg; (pemivibart) Infusion Site of Care | Locator',
        description: 'The Infusion Center Locator tool helps you quickly find locations where your patients can receive PEMGARDA infusions. Leverage this convenient tool now.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/connect-with-us/',
        title: 'PEMGARDA&reg; (pemivibart) Connect With Us | Sign Up Now',
        description: 'Would you like to receive updates on PEMGARDA or talk with a PEMGARDA Sales Representative? Simply enter your details to connect in whichever way works best for you.',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
    {
        path: '/hcp/request-facility/',
        title: 'Request Facility - INVIVYD',
        description: '',
        ogData: {
            image: '',
            type: '',
            width: '',
            height: '',
            description: ''
        }
    },
]

export { metaData as meta };
